import styled, { css } from 'styled-components';

import Tooltip from '../Tooltip';

interface ContainerProps {
  isFocused: boolean;
  isFilled: boolean;
  isErroed: boolean;
}

export const Container = styled.div<ContainerProps>`
  background: #fff;
  border-radius: 8px;
  padding: 10px;
  width: 100%;

  border: 1px solid #9e9e9e;
  color: #9e9e9e;

  display: flex;
  align-items: center;
  transition: all 0.35s ease-in-out;

  & + div {
    margin-top: 8px;
  }

  ${(props) =>
    props.isErroed &&
    css`
      border-color: #e53935;
    `}

  ${(props) =>
    props.isFocused &&
    css`
      color: #003399;
      border-color: #003399;
    `}

  ${(props) =>
    props.isFilled &&
    css`
      color: #003399;
    `}

  svg {
    margin-right: 16px;
  }

  select {
    background: transparent;
    color: #424242;
    flex: 1;
    border: none;
    width: 100%;

    &::placeholder {
      font-size: 14px;
      font-weight: 400;
      color: #9e9e9e;
    }
  }
`;

export const Error = styled(Tooltip)`
  height: 20px;
  /* margin-left: 16px; */

  svg {
    margin: 0;
  }

  span {
    background: #e53935;

    &::before {
      border-color: #e53935 transparent;
    }
  }
`;
